import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import ContactHero from "./sections/ContactHero";
import Inquiry from "./sections/Inquiry";
import Locations from "./sections/Locations";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <ContactHero />
      <Inquiry />
      <Locations />
      <Footer />
    </div>;
}